import { render, staticRenderFns } from "./digital-clock.vue?vue&type=template&id=04e59986&scoped=true&"
import script from "./digital-clock.vue?vue&type=script&lang=js&"
export * from "./digital-clock.vue?vue&type=script&lang=js&"
import style0 from "./digital-clock.vue?vue&type=style&index=0&id=04e59986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e59986",
  null
  
)

export default component.exports